<template>
  <section class="page-wrap">
    <!-- 表单搜索 start -->
    <section class="form">
      <div class="form-item">
        <el-select
          class="jn-input-style"
          v-model="formData.logistic_business_id"
          clearable
          placeholder="选择集配中心"
        >
          <el-option
            v-for="item of businessList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
      <div class="form-item">
        <span class="label">周期：</span>
        <el-select
          class="jn-input-style"
          v-model="order_cycle"
          clearable
          placeholder="选择周期"
        >
          <el-option
            v-for="item of orderCycleList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>

      <div class="form-item" v-if="order_cycle">
        <el-date-picker
          v-if="order_cycle === '1'"
          type="daterange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          align="right"
          v-model="dateTime"
          @change="(val) => changeCreateDate(val, 'daterange')"
        >
        </el-date-picker>
        <el-date-picker
          v-if="order_cycle === '2'"
          @change="(val) => changeCreateDate(val, 'month')"
          type="month"
          v-model="monthTime"
          :append-to-body="false"
          placeholder="选择月"
        >
        </el-date-picker>
      </div>

      <div class="form-item btn-wrap">
        <el-button @click="onHandleSearch" type="primary" icon="el-icon-search"
          >查询</el-button
        >
        <el-button
          type="primary"
          style="margin-left: 5px"
          icon="el-icon-refresh"
          class="refresh"
          @click="onHandleRefresh"
        ></el-button>
      </div>
    </section>
    <!-- 表单搜索 end -->

    <!-- 内容区 start -->
    <section class="content">
      <div class="count" v-loading="loadingData">
        <div class="count-wrap">
          <div
            @click="onHandleExport(item.type)"
            :style="{
              cursor: 'pointer',
              background: item.color,
            }"
            v-for="(item, index) of groupedOrderList.specials"
            :key="index"
            :class="index < 3 ? 'count-item' : 'count-item1'"
          >
            <div class="value" :style="{ color: item.font_color }">
              <span class="amount">{{ item.amt }}</span
              ><span class="unit">元</span>
            </div>
            <div class="label" :style="{ color: item.font_color }">
              {{ item.text }}
            </div>
            <i
              class="el-icon-download icon-box"
              v-if="item.type != 51 && item.type != 52 && item.type != 53"
            ></i>
          </div>

          <!-- 后续行：每行最多5个，颜色变化自动换行 -->
          <template v-for="(row, rowIndex) in groupedOrderList.rows">
            <div
              v-for="item in row"
              @click="onHandleExport(item.type)"
              :key="item.type"
              class="count-item1"
              :style="{ background: item.color, cursor: 'pointer' }"
            >
              <div class="value" :style="{ color: item.font_color }">
                <span class="amount">{{ item.amt }}</span>
                <span class="unit">元</span>
              </div>
              <div class="label" :style="{ color: item.font_color }">
                {{ item.text }}
              </div>
              <i
                class="el-icon-download icon-box"
                v-if="item.type != 51 && item.type != 52 && item.type != 53"
              ></i>
            </div>
            <!-- 补位占位符：不足5个时填充空 div 保持对齐 -->
            <div
              v-for="n in 5 - row.length"
              :key="`placeholder-${rowIndex}-${n}`"
              class="count-item1 placeholder"
            ></div>
          </template>
        </div>
      </div>
    </section>
    <!-- 内容区 end -->
  </section>
</template>

<script>
import debounce from "lodash/debounce";
import cloneDeep from "lodash/cloneDeep";
import axios from "@/api/http";
import { BASE } from "@/api/index";
const BASE_URL = BASE.EXPORT_CENTER;
import {
  postDashList,
  postOrderDataView,
  postOrderDataViewExport,
  postWalletExport,
} from "@/api/statistic/index";
import { formatDate } from "@/utils/tools/date.js";

export default {
  name: "StatisticOrderCount",
  data() {
    return {
      loadingData: true,
      disabledExport: false,
      dateTime: [], // 日期对象
      weekTime: "",
      monthTime: "",
      businessList: [], // 集配中心列表
      cityStoreList: [], // 城市仓列表
      selfTakeList: [], // 自提点列表
      countTitle: "上日14点至本日14点",
      order_cycle: "1",
      formData: {
        supply_time_start: "", // 开始时间
        supply_time_end: "", // 结束时间
        logistic_business_id: "", // 集配中心
      },
      indexKey: {
        in: "/bi/distribution/wallet/export", //平台总收入
        out: "/bi/distribution/expense/export", //平台总支出
        end: "/bi/distribution/balance/export", //平台总结语
        10: "/bi/distribution/service/fee/export", //服务费type =10
        11: "/bi/distribution/service/fee/export", //运费type =20
        30: "/bi/distribution/service/fee/share/export", //销售服务费type =10
        31: "/bi/distribution/service/fee/share/export", //第三方服务费type =20
        32: "/bi/logistics/compound/deduction/export", //供应商-复合缺货扣款type = 1
        12: "/bi/logistics/compound/deduction/export", //城市仓-复合缺货扣款type = 2
        13: "/bi/logistics/transport/fee/export", //装卸服务费 type ： 40
        14: "/bi/logistics/transport/fee/export", //保险服务费 type ： 50
        16: "/bi/logistics/transport/fee/export", //合车费 type ： 130
        15: "/bi/logistics/transport/fee/export", //场地服务费 type ： 70
        17: "/bi/logistics/transport/fee/export", //暂存费 type ： 140
        18: "/bi/logistics/other/deduction/export", //城市仓其他扣款 type: 60
        19: "/bi/logistics/other/deduction/export", //城市仓罚款type: 120
        20: "/bi/logistics/online/zero/fee/export", //自采费用 type:10
        21: "/bi/logistics/online/zero/fee/export", //线上零担  type:20
        33: "/bi/supplier/other/deduction/export", //供应商-其他扣款type: 50
        34: "/bi/supplier/other/deduction/export", //线下售后扣款 type: 60
        35: "/bi/supplier/other/deduction/export", //品控扣款type: 90
        36: "/bi/distribution/use/fee/export", //平台使用费 type :10
        37: "/bi/distribution/use/fee/export", //坑位费 type :20
        50: "/bi/distribution/coupon/export", //优惠券发放
        54: "/bi/distribution/financial/export", //平台金融手续费
      },
      formDataClone: {}, // 复制一份，用于初始化
      orderCycleList: [
        {
          id: "1",
          name: "日",
        },
        {
          id: "2",
          name: "月",
        },
      ],
      deliveryCycleList: [
        {
          id: "1",
          name: "供货日",
        },
        {
          id: "2",
          name: "自然日",
        },
      ],
      orderDataList: [],
      orderDataListClone: [],
      activeKey: "tonnage_num",
      chartsData: {},
    };
  },
  computed: {
    // 分组后的数据，前三项独立，后面按规则分组
    groupedOrderList() {
      const list = this.orderDataList;
      if (!list || list.length === 0) return { specials: [], rows: [] };

      // 前三项特殊卡片（type: 'in', 'out', 'end'）
      const specials = list.filter(
        (item) =>
          item.type === "in" || item.type === "out" || item.type === "end"
      );

      // 普通卡片
      const normal = list.filter(
        (item) => !["in", "out", "end"].includes(item.type)
      );

      // 分组：颜色变化或满5个换行
      const rows = [];
      let currentRow = [];
      let currentColor = null;

      normal.forEach((item) => {
        const itemColor = item.color;

        // 需要换行的情况：当前行已满5个 或 颜色改变
        const needNewRow =
          currentRow.length >= 5 ||
          (currentColor !== null && itemColor !== currentColor);

        if (needNewRow) {
          if (currentRow.length > 0) rows.push(currentRow);
          currentRow = [];
          currentColor = itemColor;
        } else {
          // 如果是该行第一个，记录颜色
          if (currentColor === null) currentColor = itemColor;
        }

        currentRow.push(item);
      });

      // 最后一行
      if (currentRow.length > 0) rows.push(currentRow);

      return { specials, rows };
    },
  },
  mounted() {
    this.onInitData();
  },
  methods: {
    /**
     * 初始化数据
     */
    onInitData() {
      this.onResetTime();
      this.dateTime = [
        this.formData.supply_time_start,
        this.formData.supply_time_end,
      ];
      this.formDataClone = cloneDeep(this.formData);
      this.orderDataListClone = cloneDeep(this.orderDataList);
      this.chartsData = {};

      this.ajaxGetBusinessList();
    },
    /**
     * 获得集配中心列表
     */
    async ajaxGetBusinessList() {
      try {
        const { data } = await this.$api.general.businessList();
        this.businessList = data;
        this.formData.logistic_business_id = data[0].id;
        console.log("ajax ajaxGetBusinessList", data);
        this.ajaxGetOrderDataView();
      } catch (err) {
        console.log("ajax ajaxGetBusinessList err", err);
      }
    },
    /**
     * 获取城市仓列表
     */
    ajaxGetCityStoreList: debounce(async function (data) {
      const params = {
        name: data,
        page: 1,
        pageSize: 1000,
      };
      try {
        const { data } = await this.$api.general.logisticsList(params);
        this.cityStoreList = data;
        console.log("ajx ajaxGetCityStoreList", data);
      } catch (err) {
        console.log("ajx ajaxGetCityStoreList err", err);
      }
    }, 300),
    /**
     * 获取自提点列表
     */
    ajaxGetSelfTakeList: debounce(async function ({
      name = "",
      logisticsId = "",
    }) {
      /**
       * 城市仓为必传参数
       * 防止接口在删除城市仓前请求数据，故先判断条件
       */
      if (!logisticsId || !this.formData.logistics_id) {
        return;
      }
      const params = {
        name,
        logistics_id: logisticsId || [],
        page: 1,
        pageSize: 1000,
      };
      try {
        const { data } = await this.$api.general.deliveryList(params);
        this.selfTakeList = data.data;
        console.log("ajx ajaxGetSelfTakeList", data.data);
      } catch (err) {
        console.log("ajx ajaxGetSelfTakeList err", err);
      }
    },
    500),
    /**
     * 查询列表数据
     */
    async ajaxGetOrderDataView() {
      this.loadingData = true;
      this.orderDataList = cloneDeep(this.orderDataListClone);
      const params = { ...this.formData };
      let form = cloneDeep(params);
      form.supply_time_start =
        new Date(form.supply_time_start).getTime() / 1000 || "";
      form.supply_time_end =
        new Date(form.supply_time_end).getTime() / 1000 || "";
      try {
        const { data } = await postDashList(form);
        this.orderDataList = data;
        // const { chartData, orderData } = data;
        // Object.keys(orderData).forEach((_KEY) => {
        //   const index = this.orderDataList.findIndex(
        //     (item) => item.key === _KEY
        //   );
        //   console.log(_KEY, 111111111222322323, this.orderDataList[index]);
        //   if (index != -1) {
        //     this.orderDataList[index].value = orderData[_KEY];
        //   }
        // });
        // chartData.map((item) => {
        //   Object.keys(item).forEach((_KEY) => {
        //     const index = this.orderDataList.findIndex(
        //       (item) => item.key === _KEY
        //     );
        //     this.orderDataList[index]?.xAxisData.push(item.date);
        //     this.orderDataList[index]?.seriesData.push(item[_KEY]);
        //   });
        // });
        // this.onHandleClick();
        console.log("🆒 ajaxGetOrderDataView", this.orderDataList);
      } catch (err) {
        console.log("ajax ajaxGetOrderDataView err", err);
      } finally {
        this.loadingData = false;
      }
    },
    /**
     * tab切换
     */
    onHandleClick() {
      this.chartsData = this.orderDataList.find(
        (item) => item.key === this.activeKey
      );
      // console.log("🆒 onHandleClick", this.chartsData);
    },
    /**
     * 查询表单
     */
    onHandleSearch() {
      this.ajaxGetOrderDataView();
    },
    /**
     * 重置数据
     */
    async onHandleRefresh() {
      this.formData = {
        ...this.formDataClone,
      };
      this.onResetTime();
      this.dateTime = [
        this.formData.supply_time_start,
        this.formData.supply_time_end,
      ];
      try {
        const { data } = await this.$api.general.businessList();
        this.businessList = data;
        this.formData.logistic_business_id = data[0].id;
        console.log("ajax ajaxGetBusinessList", data);
        this.ajaxGetOrderDataView();
      } catch (err) {
        console.log("ajax ajaxGetBusinessList err", err);
      }
    },
    /**
     * 重置时间
     */
    onResetTime() {
      const day = 24 * 60 * 60 * 1000;
      const start = new Date().getTime() - day;
      // this.formData.start_time = formatDate(start);
      this.formData.supply_time_start = formatDate();
      this.formData.supply_time_end = formatDate();
      console.log(
        "this.formData.supply_time_start",
        this.formData.supply_time_start
      );
      console.log(
        "this.formData.supply_time_end",
        this.formData.supply_time_end
      );
    },
    /**
     * 导出数据
     */
    async onHandleExport(key) {
      this.disabledExport = true;
      try {
        const params = { ...this.formData };
        let form = cloneDeep(params);
        form.supply_time_start =
          new Date(form.supply_time_start).getTime() / 1000 || "";
        form.supply_time_end =
          new Date(form.supply_time_end).getTime() / 1000 || "";

        switch (key) {
          case 10:
          case 30:
          case 20:
          case 36:
            form.type = 10;
            break;
          case 11:
          case 31:
          case 21:
          case 37:
            form.type = 20;
            break;
          case 14:
          case 33:
            form.type = 50;
            break;
          case 32:
            form.type = 1;
            break;
          case 12:
            form.type = 2;
            break;
          case 13:
            form.type = 40;
            break;
          case 16:
            form.type = 130;
            break;
          case 15:
            form.type = 70;
            break;
          case 17:
            form.type = 140;
            break;
          case 18:
          case 34:
            form.type = 60;
            break;
          case 19:
            form.type = 120;
            break;
          case 35:
            form.type = 90;
            break;
        }
        axios
          .post(`${BASE_URL + this.indexKey[key]}`, form)
          .then((res) => {
            console.log("res===", res);
            this.goExportCenter();
          })
          .catch((err) => {
            console.log("err", err);
          });
        // const params = {
        //   ...this.formData,
        //   token: sessionStorage.getItem("token"),
        // };
        // delete params.page;
        // delete params.pageSize;
        // await postOrderDataViewExport(params);
        // this.goExportCenter();
      } catch (err) {
        console.log("ajax postOrderDataViewExport err", err);
      } finally {
        // this.disabledExport = false;
      }
    },
    /**
     * 导出后引导弹框
     */
    goExportCenter() {
      // 新窗口打开下载中心
      const routerInfo = this.$router.resolve({
        path: "/export-center",
      });
      window.open(routerInfo.href, "_blank");
      this.disabledExport = false;
    },
    /**
     * 城市仓发生变化
     */
    onChangeCityStore(data) {
      // 重置自提点
      this.selfTakeList = [];
      this.formData.delivery_id = "";
      const params = {
        name: "",
        logisticsId: data,
      };
      this.ajaxGetSelfTakeList(params);
    },
    /**
     * 搜索数据项
     */
    onFilterMethod(type, data) {
      if (type === "cityStore") {
        this.ajaxGetCityStoreList(data);
      }
      if (type === "selfTake") {
        const params = {
          name: data,
          logisticsId: this.formData.logistics_id,
        };
        this.ajaxGetSelfTakeList(params);
      }
    },
    /**
     * 失焦时，初始化下拉框
     */
    onChangeVisible(type, data) {
      if (!data && type === "cityStore") {
        this.ajaxGetCityStoreList();
      }
      if (!data && type === "selfTake") {
        const params = {
          name: "",
          logisticsId: this.formData.logistics_id,
        };
        this.ajaxGetSelfTakeList(params);
      }
    },
    /**
     * 日期发生了变化
     */
    changeCreateDate(data, type) {
      console.log("data", data);
      if (!data) {
        this.onResetTime();
        return;
      }
      let day = 24 * 60 * 60 * 1000;
      // let start = "";
      // let end = "";
      //   console.log("🆒 changeCreateDate", data, start, end);
      if (type == "daterange") {
        this.formData.supply_time_start = data[0];
        this.formData.supply_time_end = data[1];
      }

      if (type === "month") {
        let num = new Date(
          data.getYear() % 100,
          data.getMonth() + 1,
          0
        ).getDate();
        this.formData.supply_time_start = formatDate(data);
        let endNum = data.getTime() + day * (num - 1);
        this.formData.supply_time_end = formatDate(endNum);
      }
      console.log(
        "this.formData.supply_time_start",
        this.formData.supply_time_start
      );
      console.log(
        "this.formData.supply_time_end",
        this.formData.supply_time_end
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.page-wrap {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  padding: 10px;
  .form {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    padding: 13px 15px;
    box-sizing: border-box;
    background: #ffffff;
    &-item {
      display: flex;
      .label {
        width: 90px;
        height: 36px;
        line-height: 36px;
        text-align: right;
      }
      .el-input {
        flex: 1;
      }
      &.btn-wrap {
        position: relative;
        top: -2.5px;
        left: 20px;
      }
    }
    .refresh {
      background: #333333;
      border-color: #333333;
    }
  }

  .content {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    gap: 20px;
    .placeholder {
      visibility: hidden; // 占位列不可见，但占据空间
      pointer-events: none; // 避免干扰点击
    }
    .count {
      margin-top: 20px;
      &-wrap {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 20px;
        .icon-box {
          position: absolute;
          bottom: 20px;
          right: 20px;
        }
      }
      &-item {
        width: 30%;
        padding: 20px;
        background: #fff;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
        .value {
          padding-top: 20px;
          .amount {
            font-size: 20px;
            font-weight: 700;
          }
          .unit {
            font-size: 12px;
          }
        }
      }
      &-item1 {
        width: 18%;
        padding: 20px;
        background: #fff;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
        .value {
          padding-top: 20px;
          .amount {
            font-size: 20px;
            font-weight: 700;
          }
          .unit {
            font-size: 12px;
          }
        }
      }
    }
    .charts {
      padding: 20px;
      background: #fff;
    }
  }
  .pagination {
    box-sizing: border-box;
    padding: 10px 20px;
  }
}
</style>
